// Types
import {
  CrusherOperationalData,
  EquipmentUnitCrusher,
} from '../../../../types/crusher';
import { GPS, Site } from '../../../../types/global';

export enum PatriotDrawerType {
  export = 'export',
  feederInterlock = 'feederInterlock',
  hydraulic = 'hydraulic',
  hmiAlarms = 'hmiAlarms',
  lubrication = 'lubrication',
  motorControl = 'motorControl',
  motorStatus = 'motorStatus',
}

export interface PatriotProps {
  alertText: string | null;
  equipmentUnitCrusher: EquipmentUnitCrusher;
  operationalData: CrusherOperationalData;
  site: Site;
  unitCoordinates: GPS;
  testId: string;
}
